var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTablePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 191,
    viewBox: "0 0 224 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 31.2718,
    width: 224,
    height: 158.757,
    rx: 8,
    fill: "#9868F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6602,
    y: 96.5146,
    width: 181.592,
    height: 14.1359,
    rx: 7.06796,
    fill: "#D4C0F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6602,
    y: 123.699,
    width: 93.5146,
    height: 14.1359,
    rx: 7.06796,
    fill: "#D4C0F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1844,
    cy: 60.6311,
    r: 6.52427,
    fill: "#B795F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5826,
    cy: 60.6311,
    r: 6.52427,
    fill: "#B795F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.9806,
    cy: 60.6311,
    r: 6.52427,
    fill: "#EFE5FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 131.573,
    y: 3,
    width: 64.1553,
    height: 64.1553,
    rx: 8,
    fill: "#B795F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3517_5104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 13,
    width: 44,
    height: 45
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 142.447,
    y: 13.8738,
    width: 43.4951,
    height: 43.4951,
    fill: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.133 53.7443C152.626 53.7443 150.489 52.8608 148.722 51.0938C146.955 49.3268 146.071 47.1898 146.071 44.6828C146.071 42.1758 146.955 40.0388 148.722 38.2718C150.489 36.5048 152.626 35.6213 155.133 35.6213C157.64 35.6213 159.777 36.5048 161.544 38.2718C163.311 40.0388 164.194 42.1758 164.194 44.6828C164.194 47.1898 163.311 49.3268 161.544 51.0938C159.777 52.8608 157.64 53.7443 155.133 53.7443ZM179.78 51.932L168.181 40.3333C167.819 39.9407 167.434 39.5404 167.026 39.1327C166.618 38.7249 166.218 38.3398 165.825 37.9773C166.973 37.2524 167.894 36.2859 168.589 35.0777C169.284 33.8695 169.631 32.5404 169.631 31.0906C169.631 28.8252 168.838 26.8997 167.253 25.3139C165.667 23.7281 163.741 22.9353 161.476 22.9353C159.21 22.9353 157.285 23.7281 155.699 25.3139C154.113 26.8997 153.32 28.8252 153.32 31.0906C153.32 31.2718 153.328 31.4455 153.343 31.6116C153.358 31.7778 153.381 31.9514 153.411 32.1327C152.867 32.1931 152.271 32.3139 151.621 32.4951C150.972 32.6764 150.391 32.8878 149.877 33.1294C149.817 32.7972 149.771 32.4649 149.741 32.1327C149.711 31.8004 149.696 31.4531 149.696 31.0906C149.696 27.7983 150.836 25.0119 153.117 22.7314C155.397 20.4509 158.183 19.3107 161.476 19.3107C164.768 19.3107 167.555 20.4509 169.835 22.7314C172.116 25.0119 173.256 27.7983 173.256 31.0906C173.256 32.3894 173.052 33.6203 172.644 34.7832C172.236 35.9461 171.67 37.0108 170.945 37.9773L182.317 49.3948L179.78 51.932ZM151.916 49.1683L155.133 45.9514L158.304 49.1683L159.618 47.8997L156.401 44.6828L159.618 41.466L158.35 40.1974L155.133 43.4142L151.916 40.1974L150.647 41.466L153.864 44.6828L150.647 47.8997L151.916 49.1683Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3517_5104",
    x: 119.673,
    y: 0.1,
    width: 87.9553,
    height: 87.9553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3517_5104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3517_5104",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTablePlaceholder);
export default __webpack_public_path__ + "static/media/empty-table-placeholder.516ab16160dbdd7a61798075abba916c.svg";
export { ForwardRef as ReactComponent };